/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_License_Row_Py_TitleInputs */

const es_marketplace_seo_license_row_py_title = /** @type {(inputs: Marketplace_Seo_License_Row_Py_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patrón de Yate (PY)`)
};

const gl_marketplace_seo_license_row_py_title = /** @type {(inputs: Marketplace_Seo_License_Row_Py_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patrón de Iate (PY)`)
};

const en_marketplace_seo_license_row_py_title = /** @type {(inputs: Marketplace_Seo_License_Row_Py_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yachtmaster (PY)`)
};

/**
* | output |
* | --- |
* | "Yachtmaster (PY)" |
*
* @param {Marketplace_Seo_License_Row_Py_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_license_row_py_title = /** @type {((inputs?: Marketplace_Seo_License_Row_Py_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_License_Row_Py_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_license_row_py_title(inputs)
	if (locale === "en") return en_marketplace_seo_license_row_py_title(inputs)
	return es_marketplace_seo_license_row_py_title(inputs)
});